import styled from 'styled-components';
import {
  Box,
  Dialog,
  DialogContent,
  TextField,
} from '@material-ui/core';

export const Modal = styled(Box)`
  & .MuiPaper-root {
    height: 70%;
  }
`;
export const ModalContent = styled(DialogContent)`
  padding: 8px 24px;
  overflow-y: auto;
  flex-direction: column;
  display: flex;
  align-items: center;
`;
export const RowsContainer = styled.div`
  height: '75%';
  width: '80%';
`;
export const Rows = styled.div`
  height: 45px;
  border: 1px solid black;
  border-radius: 10px;
  display: 'flex';
  flexdirection: 'row';
  alignitems: 'center';
  justifycontent: 'space-between';
  margin: 10px 0px;
  padding: 0px 5px;
`;
export const ItemsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: '25%';
`;
export const ItemTitle = styled.span`
  color: #FFA500
  font-size: 16px;
  font-Family: 'Nunito', sans-serif;
    font-weight: bold;
`;

export const Button = styled.button`
  width: ${(props) => (props.width === 'fullWidth' ? '100%' : '200px')};
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 36px;
  letter-spacing: 1px;
  margin:${(props) => (props.width === 'fullWidth' ? '0' : '10px 15px')};
  &:hover {
    background-color: #da8d00;
    border-color: #fff;
  }
  &:disabled {
    background-color: grey;
    border-color: #fff;
  }
}
`;
export const Form = styled(Dialog)`
  // & .MuiPaper-root {
  //   height: 50%;
  // }
`;

export const styles = {
  root: {
    width: '300px',
    margin: '10px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  title: {
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  testResult: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    color: 'gray',
  },
};

export const SelectInput = styled(TextField)`
  & .MuiFormControl-root {
    margin: 27px 0px 0px 0px;
    position: relative;
    padding-bottom: 10px;
    vertical-align: unset;
  }
  ,
  & .MuiFormLabel-root {
    color: #343434 !important;
    font-size: 15px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.42857;
  }
  ,
  & .MuiInput-underline:after {
    color: #343434 !important;
    font-size: 15px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.42857;
    border-color: #9c27b0;
  }
  ,
  & .MuiInput-underline:before {
    border-color: #585858 !important;
    border-width: 1px !important;
  }
`;
